import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { Box } from '@mui/material'
import Typography from '@mui/material/Typography'
import React from 'react'

type StatusIndicatorProps = {
  isComplete?: boolean
}

const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  isComplete = false,
}: StatusIndicatorProps) => {
  return (
    <Box display={'flex'} gap={1} alignItems={'center'}>
      {isComplete ? (
        <>
          <CheckCircleIcon color='success' />
          <Typography>Section Complete</Typography>
        </>
      ) : (
        <>
          <CheckCircleOutlineIcon />
          <Typography>Incomplete</Typography>
        </>
      )}
    </Box>
  )
}

export default StatusIndicator
